import RBush from 'rbush';

import { type RBushItem } from '@/microfrontends/map/shared/types/Map';

import { getExtendedTileBBox } from './getExtendedTileBBox';
import { getVisibleTiles } from './getVisibleTiles';

type GetTilesToUpdateParams = {
  rbushItems: RBushItem[];
  bounds: [YMaps.TCoord, YMaps.TCoord];
  zoom: number;
};

export function getTilesToUpdate(params: GetTilesToUpdateParams): YMaps.TTileNumber[] {
  const { rbushItems, zoom: zoomRaw, bounds } = params;

  const rBush = new RBush();

  rBush.load(rbushItems);

  const zoom = Math.round(zoomRaw);
  const visibleTilesNumbers = getVisibleTiles(bounds, zoom);

  const tilesToUpdate: YMaps.TTileNumber[] = [];

  visibleTilesNumbers.forEach(tileNumber => {
    const extendedTileBox = getExtendedTileBBox({ tileNumber, zoom });

    if (rBush.collides(extendedTileBox)) {
      tilesToUpdate.push(tileNumber);
    }
  });

  return tilesToUpdate;
}
